import { normalize } from './normalize.js';
import { dailyIndex } from './daily.js';
export class Lexicon {
    /** The target pool, normalized, in list order (the daily shuffle indexes this). */
    targets;
    validSet;
    constructor(data) {
        this.targets = data.targets.map(normalize);
        this.validSet = new Set(data.valid.map(normalize));
        // Superset guarantee: every target must be a valid guess (§4). Add rather
        // than throw — a target that slipped the build should never be unguessable.
        for (const t of this.targets)
            this.validSet.add(t);
    }
    /** §4: a fast membership check against the comprehensive list. */
    isValidGuess(word) {
        return this.validSet.has(normalize(word));
    }
    /** §4: the deterministic daily answer for a date (`YYYY-MM-DD`). */
    getDailyTarget(dateString) {
        return this.targets[dailyIndex(dateString, this.targets.length)];
    }
    /** §4: a random practice answer. */
    getRandomTarget() {
        return this.targets[Math.floor(Math.random() * this.targets.length)];
    }
    get targetCount() {
        return this.targets.length;
    }
    get validCount() {
        return this.validSet.size;
    }
}
//# sourceMappingURL=lexicon.js.map